/*
 * @Author: cc
 * @Date: 2017-12-24
 * @LastEditTime: 2021-10-13 10:53:00
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\planningResource\commandMonitor\publicOpinionMgrZj\publicOpinionMgrZj.js
 * @Description: 新疆舆情管理
 */
angular.module('publicOpinionMgrZjModule', [
    'publicOpinionMgrZjRouterModule', // 新疆舆情地图路由
    'publicOpininonMgrZjNavModule', // 新疆舆情nav切换
    'functionListModule', // 新疆舆情功能列表
    'displaySettingModule', // 新疆舆情显示设置
    'newTopicRuleModule', // 新疆舆情最新话题规则
    'burstNewsRuleModule', // 新疆舆情突发新闻规则
    'historyHotAdminModule', // 新疆舆情历史热点管理
    'shareLinkModule'
])
    . controller('publicOpinionMgrZjCtrl', [function() {
	
    }]);
